export type Tier = "high" | "mid" | "low";

export interface TierInputs {
  dpr: number;
  isMobile: boolean;
  gpuRenderer: string;
}

export interface Settings {
  pixelRatioCap: number;
  postprocess: boolean;
  postprocessFull: boolean;
  photonFlock: number;
  higgsSegments: number;
  fluxTubeSamples: number;
  sandboxMaxParticles: number;
}

const DISCRETE_RE = /\b(rtx|gtx|radeon|arc|m1 max|m1 pro|m2 max|m2 pro|m3|m4)\b/i;

export function computeTier(i: TierInputs): Tier {
  if (i.isMobile) return "low";
  if (i.dpr >= 2 && DISCRETE_RE.test(i.gpuRenderer)) return "high";
  return "mid";
}

export function settingsForTier(t: Tier): Settings {
  switch (t) {
    case "high":
      return {
        pixelRatioCap: 2.0, postprocess: true, postprocessFull: true,
        photonFlock: 4096, higgsSegments: 256, fluxTubeSamples: 64,
        sandboxMaxParticles: 300,
      };
    case "mid":
      return {
        pixelRatioCap: 1.5, postprocess: true, postprocessFull: false,
        photonFlock: 2048, higgsSegments: 128, fluxTubeSamples: 32,
        sandboxMaxParticles: 200,
      };
    case "low":
      return {
        pixelRatioCap: 1.25, postprocess: false, postprocessFull: false,
        photonFlock: 512, higgsSegments: 64, fluxTubeSamples: 16,
        sandboxMaxParticles: 80,
      };
  }
}

export function detectFromBrowser(): Tier {
  const dpr = window.devicePixelRatio || 1;
  const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  let gpuRenderer = "";
  try {
    const c = document.createElement("canvas");
    const gl = (c.getContext("webgl2") || c.getContext("webgl")) as WebGLRenderingContext | null;
    if (gl) {
      const ext = gl.getExtension("WEBGL_debug_renderer_info");
      if (ext) gpuRenderer = String(gl.getParameter((ext as any).UNMASKED_RENDERER_WEBGL));
    }
  } catch {}
  return computeTier({ dpr, isMobile, gpuRenderer });
}
